import logo_blue from "./logo.png";

export const icons = {
  logo_blue,
};
